import { SignalSettings } from '../../../../types/signalSettings';

export const DEFAULT_LIMIT_ORDER_TIMEOUT_MINUTES = 40;

export const timeSpanToMinutes = (timeSpan: string): number | null => {
  const match = /^(?:(\d+)\.)?(\d{1,2}):([0-5]\d):([0-5]\d)(?:\.\d+)?$/.exec(timeSpan);

  if (!match) return null;

  const [, days = '0', hours, minutes, seconds] = match;
  const totalSeconds = Number(days) * 24 * 60 * 60 + Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);

  return Math.floor(totalSeconds / 60);
};

export const getLimitOrderTimeoutMax = (
  settings: SignalSettings | undefined,
  classCode: string | undefined,
): number => {
  if (!settings) return DEFAULT_LIMIT_ORDER_TIMEOUT_MINUTES;

  const classCodeTimeout = Object.entries(settings.limitOrderTimeoutByClassCode || {}).find(
    ([key]) => key.toLowerCase() === classCode?.toLowerCase(),
  )?.[1];

  return (
    timeSpanToMinutes(classCodeTimeout || settings.defaultLimitOrderTimeout) ?? DEFAULT_LIMIT_ORDER_TIMEOUT_MINUTES
  );
};
